import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { IReduxState } from 'src/reduxTypes';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import { IAuthState } from 'src/modules/Auth/store/types';
import { StatisticsService, StatsTypes } from 'src/share/services/statistics';
import { ProvidersService } from 'src/share/services/providers';
import DatesChart from 'src/share/components/Chart/ChartDays';
import ChartBars from 'src/share/components/Chart/ChartBars';
import AgencyFilter from 'src/share/components/AgencyFilter/AgencyFilter';
import MonthlyFilter, { IMonthOption } from 'src/share/components/MonthlyFilter/MonthlyFilter';
import { countUp } from 'src/modules/Dashboard/Global/components/CountUp';
import { ReportsService, ReportTypes, MatchReportsOptions } from 'src/share/services/reports';
import CircleChart from 'src/share/components/Chart/CircleChart';
import ProviderFilter from 'src/share/components/ProviderFilter/ProviderFilter';
import { IMatchesStats, initialMatchesStats } from 'src/share/types/adhoc';
import { IProvider } from 'src/share/types/provider';
import { getOptions } from 'src/share/utils/utils';
import { RoutesModules } from 'src/modules/Routing/types';
import ChartLoader from 'src/share/components/ChartLoader/ChartLoader';
import { YearLoader } from 'src/share/components/ChartLoader/YearLoader';
import { SexLoader } from 'src/share/components/ChartLoader/SexLoader';
import { AbductorLoader } from 'src/share/components/ChartLoader/AbductorLoader';
import './matchesStats.css';

export interface IMatchesStatsProps {
  auth: IAuthState;
  location: Location;
}

export interface IMAtchesStatsState {
  agencyCode: string;
  options: IMonthOption[];
  loading: boolean;
  selected: IMonthOption;
  matchesStats: IMatchesStats;
  loadingReport: string;
  provider: string;
  providers: IProvider[]
}

export class MatchesStats extends React.Component<IMatchesStatsProps, IMAtchesStatsState> {
  constructor(props: IMatchesStatsProps) {
    super(props);
    const options = getOptions()
    this.state = {
      options,
      selected: options[0],
      agencyCode: props.auth.agencyCode,
      matchesStats: initialMatchesStats,
      loading: true,
      loadingReport: '',
      provider: 'ALL',
      providers: []
    }
  }

  public componentDidMount() {
    this.loadData();
  }

  public async loadData() {
    try {
      this.setState({ loading: true });
      const { agencyCode, provider, selected: { gte, lte } } = this.state;
      const providers = await ProvidersService.get();
      const filters = { agencyCode, range: { gte, lte }, provider: provider.split("-").pop() };
      const matchesStats = await StatisticsService.getStats(StatsTypes.MATCHES, filters);
      this.setState({ matchesStats, providers, loading: false });
    } catch {
      toastr.error('Error', 'There was a problem loading the Matches stats');
      this.setState({ matchesStats: initialMatchesStats, loading: false });
    }
  }

  public changeAgency = async (agencyCode) => {
    this.setState({ agencyCode }, () => this.loadData())
  }

  public changeProvider = async (provider) => {
    this.setState({ provider }, () => this.loadData())
  }

  public changeMonth = async (selected: IMonthOption) => {
    this.setState({ selected }, () => this.loadData())
  }

  public getReport = (type) => async () => {
    try {
      this.setState({ loadingReport: type });
      const { agencyCode, provider, selected: { gte, lte } } = this.state;
      const filters = { agencyCode, range: { gte, lte }, provider: provider.split("-").pop() };
      await ReportsService.get(ReportTypes.MATCHES, type, filters);
    } catch (error) {
      toastr.error('Error', 'There was a problem getting the report');
    }
    this.setState({ loadingReport: '' });
  }

  public render() {
    const { agencyCode, matchesStats: { automatic, manual, manual: { agenciesSearches, agenciesMatches, providersSearches, providersMatches, results } },
      provider, providers, loading } = this.state;
    const providerId = provider.split('-').pop();
    const showAutomatic = providerId !== 'visualsearch' && providerId !== 'pimeyes' && providerId !== 'tineye';
    const { auth } = this.props;
    return (
      <div className="matches-stats">
        <ProviderFilter changeProvider={this.changeProvider} providers={providers} selected={provider} />
        <AgencyFilter changeAgency={this.changeAgency} showOnlyAdmin={auth.agencyCode === 'ALL'} loading={loading} />
        <MonthlyFilter changeSelected={this.changeMonth} options={this.state.options} selected={this.state.selected} />
        <Row>
          <Col className="col-12 no-padding-left totals">
            <Col className="col-12 content white-background">
              <Row>
                <Col xs={12} md={4}><h3>Manual matches: {!loading && <span>{countUp(manual.totalMatches)}</span>}</h3></Col>
                <Col xs={12} md={4}><h3>Manual searches: {!loading && <span>{countUp(results)}</span>}</h3></Col>
                {showAutomatic && <Col xs={12} md={4}><h3>Automatic matches: {!loading && <span>{countUp(automatic.results)}</span>}</h3></Col>}
                {!showAutomatic && <Col xs={12} md={4}><h3>Agencies: {!loading && <span>{countUp(agenciesSearches.length)}</span>}</h3></Col>}
              </Row>
              <Row>
                {auth.agencyCode === 'ALL' && agencyCode === 'ALL' && provider === 'ALL' &&
                  <><Col xs={12} md={4}><h3>Agencies: {!loading && <span>{countUp(agenciesSearches.length)}</span>}</h3></Col>
                    <Col xs={12} md={4}><h3>Providers: {!loading && <span>{countUp(providersSearches.length)}</span>}</h3></Col></>}
              </Row>
            </Col>
          </Col>
        </Row>
        <Row>
          <Col className="col-12 no-padding-left">
            <Col className="col-12 content white-background">
              <Header text={"Daily manual searches "} id='dailyManualSearches' action={this.getReport(MatchReportsOptions.DAILY_MANUAL_SEARCHES)} loading={this.state.loadingReport} download={manual.dailySearches.length > 0} />
              <ChartLoader chart={DatesChart} loader={YearLoader} data={manual.dailySearches} dataKey={'Searches'} strokePrimary={true} loading={loading} />
            </Col>
          </Col>
        </Row>
        <Row>
          <Col className="col-12 no-padding-left">
            <Col className="col-12 content white-background">
              <Header text={"Daily manual matches "} id='dailyManualMatches' action={this.getReport(MatchReportsOptions.DAILY_MANUAL_MATCHES)} loading={this.state.loadingReport} download={manual.dailyMatches.length > 0} />
              <ChartLoader chart={DatesChart} loader={YearLoader} data={manual.dailyMatches} dataKey={'Matches'} strokePrimary={false} loading={loading} />
            </Col>
          </Col>
        </Row>
        {showAutomatic && automatic.daily &&
          <Row>
            <Col className="col-12 no-padding-left">
              <Col className="col-12 content white-background">
                <Header text={"Daily automatic matches "} id='dailyAutomaticMatches' action={this.getReport(MatchReportsOptions.DAILY_AUTOMATIC_MATCHES)} loading={this.state.loadingReport} download={automatic.daily.length > 0} />
                <ChartLoader chart={DatesChart} loader={YearLoader} data={automatic.daily} dataKey={'Matches'} strokePrimary={showAutomatic} loading={loading} />
              </Col>
            </Col>
          </Row>}
        {agencyCode === 'ALL' &&
          <Row className="margin-big-card half-cards">
            <Col className="col-md-6 col-12 no-padding-left">
              <Col className="col-12 imps content white-background">
                <Header text={"Manual searches by agency "} id='manualSearchesByAgency' action={this.getReport(MatchReportsOptions.MANUAL_SEARCHES_BY_AGENCY)} loading={this.state.loadingReport} download={agenciesSearches.length > 0} />
                <ChartLoader chart={CircleChart} loader={SexLoader} data={agenciesSearches} loading={loading} />
              </Col>
            </Col>
            <Col className="col-md-6 col-12 no-padding-right">
              <Col className="col-12 imps content white-background">
                <Header text={"Manual matches by agency "} id='manualMatchesByAgency' action={this.getReport(MatchReportsOptions.MANUAL_MATCHES_BY_AGENCY)} loading={this.state.loadingReport} download={agenciesMatches.length > 0} />
                <ChartLoader chart={ChartBars} loader={AbductorLoader} data={agenciesMatches} loading={this.state.loading} />
              </Col>
            </Col>
          </Row>}
        {provider === 'ALL' &&
          <Row>
            <Col className="col-md-6 col-12 no-padding-left">
              <Col className="col-12 clicks content white-background">
                <Header text={"Manual searches by provider "} id='manualSearchesByProvider' action={this.getReport(MatchReportsOptions.MANUAL_SEARCHES_BY_PROVIDER)} loading={this.state.loadingReport} download={providersSearches.length > 0} />
                <ChartLoader chart={CircleChart} loader={SexLoader} data={providersSearches} loading={loading} />
              </Col>
            </Col>
            <Col className="col-md-6 col-12 no-padding-right">
              <Col className="col-12 clicks content white-background">
                <Header text={"Manual matches by provider "} id='manualMatchesByProvider' action={this.getReport(MatchReportsOptions.MANUAL_MATCHES_BY_PROVIDER)} loading={this.state.loadingReport} download={providersMatches.length > 0} />
                <ChartLoader chart={ChartBars} loader={AbductorLoader} data={providersMatches} loading={this.state.loading} />
              </Col>
            </Col>
          </Row>}
      </div>
    );
  }
}

const mapStateToProps = (state: IReduxState) => ({
  auth: state.auth
});

export default SidebarContainer(RoutesModules.SEARCH)(connect(mapStateToProps, null)(MatchesStats));

const Header: React.SFC<{ id: string, loading: string, text: string, action: () => void, download?: boolean }> = (props) => {
  return (
    <h5>
      {props.text}
      {props.download && <div onClick={props.action} className="subOption">
        {props.loading !== props.id && "(download)"}
        {props.loading === props.id && <i className="fa fa-circle-o-notch fa-spin fa-1x fa-fw" />}
      </div>}
    </h5>
  );
};